import {isNullOrUndefined} from "../../../services/Validator";

export default function GlossaryTermWordText({word, search, highlight}) {
    // Used in

    // BUILD
    if (isNullOrUndefined(word))
        return null
    return (
        <div className="font-bold text-lg"
             dangerouslySetInnerHTML={{ __html: highlight(word, search) }} />
    );
}